import {useState, useEffect} from "react";
import globalState from "../../shared-services/globalState";

const useCookieConsentBanner = () => {
  const [instance, setInstance] = useState(null);
  const [currenConsentState, setCurrentConsentState] = useState(null);
  const [cookieConsentBannerOpen, setConsentBannerOpen] = useState(false);

  const {setGlobalState} = globalState();

  const showConsentBanner = () => {
    if (!instance) return;

    instance.show();
  };

  const hideConsentBanner = () => {
    if (!instance) return;

    instance.hide();
  };

  const setBannerInstance = () => {
    const script = window.CookieScript;
    setInstance(script?.instance);
  };

  const setBannerOpenState = (isOpen) => {
    setConsentBannerOpen(isOpen);
    setGlobalState("topLayer", {cookieBannerOpen: isOpen});
  };

  const onSubmit = () => {
    setBannerOpenState(false);
  };

  useEffect(() => {
    if (!instance) return;

    setCurrentConsentState(instance?.currentState()?.action);
  }, [instance]);

  useEffect(() => {
    if (currenConsentState !== null) setBannerOpenState(!currenConsentState);
  }, [currenConsentState]);

  useEffect(() => {
    const events = {
      CookieScriptLoaded: setBannerInstance,
      CookieScriptAcceptAll: onSubmit,
      CookieScriptAccept: onSubmit,
      CookieScriptReject: onSubmit,
      CookieScriptClose: onSubmit
    };

    Object.keys(events).forEach(eventName => addEventListener(eventName, events[eventName]));

    return () => {
      Object.keys(events).forEach(eventName => removeEventListener(eventName, events[eventName]));
    };
  }, []);

  return {cookieConsentBannerOpen, showConsentBanner, hideConsentBanner};
};

export default useCookieConsentBanner;
